exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-transition-enter-active[data-v-5a91def5],.page-transition-leave-active[data-v-5a91def5]{-webkit-transition:opacity .28s ease,-webkit-transform .28s ease;transition:opacity .28s ease,-webkit-transform .28s ease;transition:opacity .28s ease,transform .28s ease;transition:opacity .28s ease,transform .28s ease,-webkit-transform .28s ease}.page-transition-enter[data-v-5a91def5]{opacity:0;-webkit-transform:translateY(18px);transform:translateY(18px)}.page-transition-leave-to[data-v-5a91def5]{opacity:0;-webkit-transform:translateY(-10px);transform:translateY(-10px)}@media (prefers-reduced-motion:reduce){.page-transition-enter-active[data-v-5a91def5],.page-transition-leave-active[data-v-5a91def5]{-webkit-transition:none;transition:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a91def5","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/index.vue
// module id = J6Hn
// module chunks = 1